import type { IconSvgObject } from './types';

const TriangleRightIcon: IconSvgObject = [
  ["path", { d: "M21.9999 5.11394V17.9996C21.9999 19.1042 21.1045 19.9996 19.9999 19.9996H3.0093C2.45181 19.9996 1.99988 19.5477 1.99988 18.9902C1.99988 18.68 2.14248 18.3871 2.38661 18.1957L20.1969 4.2363C20.3932 4.08245 20.6354 3.99884 20.8848 3.99884C21.5007 3.99884 21.9999 4.49809 21.9999 5.11394Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default TriangleRightIcon;
